import { useEffect, useState } from 'react'
import axios, { CancelToken } from 'axios'

const useLoanCalculation = (apiUrl, companyId, accessToken, carInfo, productId, productData, downPayment, loanDurationInMonths, interestType) => {
  const [loanCalculationData, setLoanCalculationData] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!carInfo || !productId || !productData || !downPayment || !loanDurationInMonths || !interestType) {
      return
    }

    const source = CancelToken.source()

    const interestRate = {
      Fixed: productData?.interestRateRangeFixed?.defaultValue,
      Variable: productData?.interestRateRangeVariable?.defaultValue
    }

    const fetchLoanCalculation = async () => {
      const url = `${apiUrl}/FinancialManagement/Company/${companyId}/Nordania/LoanCalculation`
      const loanData = {
        'productId': productId,
        'upfrontPayment': downPayment,
        'interestRate': interestRate[interestType],
        'interestType': interestType,
        'durationInMonths': loanDurationInMonths,
        'isNewVehicle': false,
        'registrationPlateOutlay': productData.registrationPlateOutlay,
        'registrationPlateType': 'Private',
        'vehiclePriceInVat': carInfo.loan_price,
        'vehiclePriceExVat': carInfo.loan_price * 0.8,
        'vehicleIdentificationType': 'AssetId',
        'vehicleIdentification': 'testvehicle',
        'vehicleBrandName': carInfo.vehicleBrandName || 'unknown',
        'vehicleEngineName': carInfo.vehicleEngineName || 'unknown',
        'vehicleGearType': carInfo.vehicleGearType || 'unknown',
        'vehicleModelName': carInfo.vehicleModelName || carInfo.vehicleVariantName || 'unknown',
        'vehicleFirstRegistrationDate': carInfo.vehicleFirstRegistrationDate.split('-').reverse().join('-')  || '2023-01-01',
        'vehicleVariantName': carInfo.vehicleVariantName || 'unknown',
        'vehicleColourName': carInfo.vehicleColourName || 'unknown',
        'vehicleRegistrationNumber': carInfo.vehicleRegistrationNumber,
        'vehicleModelYear': parseInt(carInfo.vehicleModelYear)
      }

      try {
        setIsLoading(true)

        const response = await axios.post(url, loanData, {
          cancelToken: source.token, // Pass the cancel token
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
          }
        })
        setLoanCalculationData(response.data)
        setError(null)
        setIsLoading(false)
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log('Request canceled:', error.message)
        } else {
          console.error('HTTP Error:', error.message)
          setError(error)
          setIsLoading(false)
        }
      }
    }

    fetchLoanCalculation()

    return () => {
      source.cancel('Request canceled') // Cancel the request when the component unmounts
    }
  }, [carInfo, productId, productData, downPayment, loanDurationInMonths, interestType])

  return {
    loanCalculationData,
    loanCalculationIsLoading: isLoading,
    loanCalculationError: error
  }
}

export default useLoanCalculation
